import {useEffect, useState} from 'react';
import RespondModal from "../news_box/nowe_sprawy/RespondModal";
import {faCircle, faTag, faClock} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {timestampToDate} from '../../../../functions/Functions';
import { changeIfRead } from '../../../../functions/api';

function Problem(props) {
    const {problem_content, id, problem_list, category, date, if_read, valuation, url, active, city, index, update, active_id, option, setActiveId} = props

    const problem_list_option = Object.keys(problem_list)[0];
    
    const problem_list_content = Object.values(problem_list)[0];
    const {results} = problem_list_content || ''
    
    let category_name = '';
    if (category) {
        category_name = (
            <span title="kategoria">
                <FontAwesomeIcon icon={faTag} /> 
                    {category.name}&nbsp;
            </span>
        )
    }
    let {was_read_by_lawyer} = results
    if(!was_read_by_lawyer) {
        was_read_by_lawyer = ''
    }
    const [if_limit, setLimit] = useState(true);
    const [show, setShow] = useState(false);

    useEffect(() => {
        if (id === active_id && problem_list_option === 'request') {
            setShow(true)
            changeIfRead(active, id,  results[index].forum, false, update)
        } 
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[active_id, results, option])
    
    const handleClick = () => {
        if(active === 1) {
            setShow(true);
        }
        changeIfRead(active, id,  results[index].forum, false, update)
    }

    const showMore = (e) => {
        setLimit(!if_limit)
        e.preventDefault();
    }
    const textLimit = (text) => {
        const limit_to = 150
        if(if_limit && text.length >= limit_to) {
            text = text.slice(0, limit_to) + '...';
        }
        return text
    }
        let valuation_element = '';
        let was_read = '';
        let value = ''
        if (if_limit && problem_content.length >= 450) {
            value = 'pokaż więcej'
        }
        if (valuation) {
            valuation_element =  <span title="Wycena"> Wycena </span>
        }
        if (if_read) {
            was_read = (<div className="pointer-was-read" onClick={()=> {changeIfRead(0, id,  results[index].forum, results[index].was_read_by_lawyer, update)}}>
                                <span>Przeczytano</span>
                                <FontAwesomeIcon icon={faCircle} />
                            </div>)
        } else {
            was_read = (<div className="pointer-was-read" onClick={()=> {changeIfRead(0, id,  results[index].forum, results[index].was_read_by_lawyer, update)}}>
                                <span>Nieprzeczytano</span>
                                <FontAwesomeIcon icon={faCircle} />
                            </div>)
        }

        return (
            <div className={`problem ${(if_read) ? 'read' : ''}`}>
                <div className="problem-content shadow-box"  >
                    <a className="nofocus pointer" href={`${active === 0 ? `${url}` : '#'}`} onClick={handleClick}>
                            {textLimit(problem_content)}
                        <span className="btn-link" onClick={showMore}>{value}</span>
                    </a>
                </div>
                <div className="problem-info">
                    <div>
                        <span title="ID problemu" >
                            ID: {id} &nbsp; 
                        </span>
                        {category_name}
                        <span title="Data wysłania">
                            <FontAwesomeIcon icon={faClock}/>
                            {timestampToDate(date)}
                            &nbsp;
                        </span>
                        {valuation_element}
                    </div>
                        {was_read}
                </div>
                <RespondModal show={show} setShow={setShow} problem_content={problem_content}
                id={id}
                date={date}
                category={category}
                city={city} 
                update={update}
                setActiveId={setActiveId}
                />
            </div>
        )
}

export default Problem;